import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { models } from 'powerbi-client'
import { PowerBIEmbed } from 'powerbi-client-react'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import { GET_POWER_BI_TOKEN } from '../../../../graphql/Catalog/PowerBi/powerBi'

const TestPowerBi = () => {
  //HOOKS
  const [loading, setLoading] = useState(true)
  const [accessToken, setAccessToken] = useState('')

  //QUERY
  const {
    data: dataPowerBiToken,
    loading: loadingPowerBiToken,
    error: errorPowerBiToken,
  } = useQuery(GET_POWER_BI_TOKEN)

  //EFFECT
  useEffect(() => {
    if (!loadingPowerBiToken) {
      if (errorPowerBiToken)
        return toastSweetAlert({
          mode: 'error',
          message: 'something has happend',
        })
      //Get Access token
      const token = dataPowerBiToken?.getPowerBiToken?.token
        ? dataPowerBiToken.getPowerBiToken.token
        : null
      setAccessToken(token)

      setLoading(false)
    }
  }, [dataPowerBiToken, loadingPowerBiToken, errorPowerBiToken])

  return (
    <>
      {!loading && (
        <div className="row desktop-view">
          <div
            className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            id="report-container"
          >
            <PowerBIEmbed
              embedConfig={{
                type: 'report', // Supported types: report, dashboard, tile, visual, and qna.
                id: '22f11eb5-4aa6-478c-a89b-bf043145228d',
                //uniqueId: '6f873651-3119-486e-a733-53ddadd47dfe',
                //permissions: models.Permissions.All,
                embedUrl:
                  'https://app.powerbi.com/reportEmbed?reportId=22f11eb5-4aa6-478c-a89b-bf043145228d&groupId=e49f260a-291f-465e-9e22-07bf136d77d6&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUNBTkFEQS1DRU5UUkFMLUItUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d',
                accessToken,
                tokenType: models.TokenType.Aad, // Use models.TokenType.Aad if you're embedding for your organization.
                settings: {
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false,
                    },
                    pageNavigation: {
                      visible: true,
                    },
                  },
                },
              }}
              eventHandlers={
                new Map([
                  [
                    'loaded',
                    function () {
                      console.log('Report loaded')
                    },
                  ],
                  [
                    'rendered',
                    function () {
                      console.log('Report rendered')
                    },
                  ],
                  [
                    'error',
                    function (event) {
                      console.log(event.detail)
                    },
                  ],
                ])
              }
              cssClassName={'embed-container'}
              getEmbeddedComponent={(embeddedReport) => {
                window.report = embeddedReport
              }}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default TestPowerBi
